module.exports = __webpack_public_path__ + "static/img/tshirt2_r.d007f9bf.webp";